/* eslint-disable */
import { LoadingSpinner } from "../../../components";
import styles from "./LoginLoader.module.css";

export function LoginLoader() {
  return (
    <div className={styles.loading}>
      <LoadingSpinner />
    </div>
  );
}
